<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_x"></a><a id="page_xi"></a>In the name of God Amen. I George Frederick Handel considering the uncertainties of human life doe make this my will in manner following …</p>
<p class="right">Last testament of George Frederick Handel</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?0ed60d1e